module.exports = __webpack_public_path__ + "static/marche-ext-9007cb45e7edb7cfb63689c5d0f57cb0.woff";